import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfRates } from '../../rateSchema'

export default rates => {
    const ratesData = pathOr([], ['_embedded', 'hotels24Rates'], rates)
    return { ...normalize(ratesData, arrayOfRates) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/h24Parsers/h24Rates.js